var _defs, _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEthCoinSpin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 48,
    height: 48,
    role: "img",
    "aria-label": "ETH coin",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "coin",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--color-accent,#37E5FF)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--color-primary,#7C4DFF)"
  })), /*#__PURE__*/React.createElement("style", null, "\n      .ring { fill: none; stroke: url(#coin); stroke-width: 4; opacity:.9 }\n      .face { fill: url(#coin); opacity:.18 }\n      .logo { fill: #fff; opacity:.95; transform-origin: 32px 32px; animation: spin 3s linear infinite; }\n      @keyframes spin { to { transform: rotate(360deg); } }\n      @media (prefers-reduced-motion: reduce) { .logo { animation: none } }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "face",
    cx: 32,
    cy: 32,
    r: 28
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "ring",
    cx: 32,
    cy: 32,
    r: 28
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "logo",
    d: "M32 10L22 30l10 6 10-6-10-20zm0 44l-10-14 10 6 10-6-10 14z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthCoinSpin);
export default __webpack_public_path__ + "static/media/eth-coin-spin.42560837bfb0b638f9f0359dce8e873a.svg";
export { ForwardRef as ReactComponent };